<template>
    <section class="grid-flex center">
        <div>
            <div class="box-content flex txt-center center">
                <div>
                    <div class="img-warning" style="margin-top: 30px">
                        <img src="@/assets/img/warning-logo.png" width="120">
                    </div>

                    <div class="margin-top-l">
                        <h2>Você chegou ao fim dos 14 dias de teste!</h2>
                        <br>
                        <h3>Plano: {{ planName }}</h3>
                        <br>
                        <p>Para continuar usando a plataforma você precisa fazer o upgrade de plano!</p>
                        <br>
                        <p>Clique Abaixo para continuar usando:</p>
                        <br>
                        <router-link :to="{ name: 'SubscriptionRedirect' }">
                            <div class="button primary">
                                <span>Assinar a plataforma</span>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import { mapState } from "vuex";


export default {
    name: 'limit_exceeded_freemium',
    data() {
        return {
        }
    },
    computed: {
        ...mapState({
            account: (state) => state.account,
        }),
        planName() {
            if (this.account && this.account.plan == 'freemium') {
                return 'Gratuito'
            }
            return this.account && this.account.plan
        },
    }
}
</script>

<style lang="css" scoped>
    @keyframes treme {
        0% {margin-left: 0; margin-top: 0}
        25% {margin-left: 5px; margin-top: 5px;}
        50% {margin-left: 0; margin-top: 0;}
        75% {margin-left: -5px; margin-top: -5px;}
        100% {margin-left: 0; margin-top: 0;}
    }

    .box {
        animation: treme 0.3s;
        animation-iteration-count: 4;
    }


</style>
